import { capitalizeEachWord } from '~/modules/helpers/string';
import { noDataColType } from "./types";

export const noDataColFactory = (id, desc) => ({
    headerName: '',
    sortable: false,
    resizable: false,
    checkboxSelection: false,
    headerCheckboxSelection: false,
    suppressSizeToFit: true,
    ...desc,
    colId: id,
    field: `__${id}__`,
    type: noDataColType
});

const noDataFieldRegEx = /^__.*__$/;

export const toBeConsideredAsDataField = str => str ? !noDataFieldRegEx.test(str) : false;

export const toHeaderName = str => capitalizeEachWord(str?.replace('_', '\u0020'));

//----------------------------------------------------------------------------------------------------------------------
/*
export const columnsPreferredProperties = ['field', 'hide', 'sort', 'pinned'];
//ag-grid.com/javascript-grid-column-properties
[
    'field',
    'type',
    'width',
    'minWidth',
    'maxWidth',
    'defaultWidth',
    'checkboxSelection',
    'resizable',
    'sortable',
    'sortingOrder',
    'flex',
    //'initialFlex',
    'suppressSizeToFit',
    'suppressMovable',
    'headerName',
    'headerClass',
    'headerComponent',
    'headerComponentFramework',
    'cellClass',
    'cellClassRules',
    'cellRenderer',
    'cellRendererParams',
    'cellRendererFramework',
    'onCellClicked',
    'onCellDoubleClicked',
    'pinned'
    //'pinnedRowCellRenderer',
    //'pinnedRowCellRendererFramework',
    //'pinnedRowCellRendererParams',
    //'autoHeight',
    //'wrapText',
];
*/
